import { gql } from "@apollo/client";

export const CREATE_JOB_POST_MUTATION = gql`
  mutation CreateJobPost($input: BackofficeCreateJobPostInput!, $application: BackofficeJobApplicationFormInput) {
    createJobPost(input: $input, application: $application) {
      success
      message
      code
      jobPost {
        id
        name
      }
    }
  }
`;

export const GET_JOB_CATEGORIES_QUERY = gql`
  query GetJobCategories {
    jobPostCategories {
      name
    }
  }
`;

export const UPDATE_JOB_POST_MUTATION = gql`
  mutation PatchJobPost($input: BackofficePatchJobPostInput!, $application: BackofficeJobApplicationFormInput) {
    patchJobPost(input: $input, application: $application) {
      success
      message
      jobPost {
        id
        name
        status
        stage
      }
    }
  }
`;
